import React from 'react';

export const AudioSoundSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      width="50pt"
      height="50pt"
      viewBox="0 0 50 50"
      version="1.1"
    >
      <g id="surface1065551">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(58.431373%,64.705882%,65.098039%)',
            fillOpacity: 1,
          }}
          d="M 49.414062 25 C 49.414062 11.621094 38.566406 0.773438 25.183594 0.773438 C 11.804688 0.773438 0.957031 11.621094 0.957031 25 C 0.957031 38.378906 11.804688 49.226562 25.183594 49.226562 C 38.566406 49.226562 49.414062 38.378906 49.414062 25 Z M 49.414062 25 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(92.54902%,94.117647%,94.509804%)',
            fillOpacity: 1,
          }}
          d="M 25.15625 13.007812 C 24.824219 12.824219 24.414062 12.84375 24.101562 13.046875 L 14.816406 19.082031 L 11.378906 19.082031 C 10.8125 19.082031 10.34375 19.539062 10.34375 20.117188 L 10.34375 29.167969 C 10.34375 29.734375 10.800781 30.203125 11.378906 30.203125 L 14.816406 30.203125 L 24.101562 36.238281 C 24.269531 36.347656 24.472656 36.40625 24.667969 36.40625 C 24.835938 36.40625 25.011719 36.367188 25.15625 36.277344 C 25.488281 36.09375 25.695312 35.75 25.695312 35.371094 L 25.695312 13.914062 C 25.695312 13.535156 25.488281 13.183594 25.15625 13.007812 Z M 28.566406 31.953125 C 28.652344 31.953125 28.738281 31.933594 28.828125 31.90625 C 31.191406 30.988281 32.785156 28.144531 32.785156 24.835938 C 32.785156 21.90625 31.496094 19.269531 29.503906 18.097656 C 29.160156 17.890625 28.710938 18.007812 28.507812 18.359375 C 28.300781 18.703125 28.417969 19.152344 28.769531 19.355469 C 30.332031 20.273438 31.339844 22.421875 31.339844 24.84375 C 31.339844 27.519531 30.089844 29.863281 28.300781 30.558594 C 27.929688 30.703125 27.746094 31.125 27.890625 31.496094 C 28.007812 31.777344 28.28125 31.953125 28.566406 31.953125 Z M 28.566406 31.953125 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(92.54902%,94.117647%,94.509804%)',
            fillOpacity: 1,
          }}
          d="M 30.460938 34.96875 C 30.546875 34.96875 30.636719 34.949219 30.722656 34.921875 C 34.042969 33.632812 36.367188 29.453125 36.367188 24.765625 C 36.367188 20.546875 34.523438 16.738281 31.671875 15.070312 C 31.328125 14.863281 30.878906 14.980469 30.675781 15.332031 C 30.46875 15.675781 30.585938 16.121094 30.9375 16.328125 C 33.359375 17.742188 34.921875 21.066406 34.921875 24.777344 C 34.921875 28.878906 32.980469 32.5 30.195312 33.585938 C 29.824219 33.730469 29.640625 34.152344 29.785156 34.523438 C 29.894531 34.796875 30.167969 34.972656 30.460938 34.972656 Z M 30.460938 34.96875 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(92.54902%,94.117647%,94.509804%)',
            fillOpacity: 1,
          }}
          d="M 32.410156 37.851562 C 32.117188 37.851562 31.84375 37.675781 31.726562 37.382812 C 31.582031 37 31.765625 36.582031 32.148438 36.433594 C 35.9375 34.960938 38.574219 30.144531 38.574219 24.714844 C 38.574219 19.824219 36.464844 15.417969 33.191406 13.503906 C 32.839844 13.300781 32.722656 12.851562 32.929688 12.5 C 33.132812 12.148438 33.582031 12.03125 33.933594 12.234375 C 37.636719 14.402344 40.039062 19.304688 40.039062 24.707031 C 40.039062 30.730469 37.011719 36.113281 32.675781 37.792969 C 32.585938 37.839844 32.5 37.851562 32.410156 37.851562 Z M 32.410156 37.851562 "
        />
      </g>
    </svg>
  );
};
